import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "login-page",
  relative: ""
}
const _hoisted_2 = ["disabled", "onInput", "onSubmit"]
const _hoisted_3 = { class: "amplify-flex amplify-authenticator__column" }
const _hoisted_4 = { class: "amplify-flex amplify-authenticator__column" }
const _hoisted_5 = { class: "amplify-flex amplify-field amplify-textfield" }
const _hoisted_6 = {
  ref: "email",
  class: "amplify-input amplify-field-group__control",
  placeholder: "Enter your email",
  type: "email",
  name: "username",
  required: "true"
}
const _hoisted_7 = {
  ref: "password",
  class: "amplify-input amplify-field-group__control",
  type: "password",
  name: "password",
  required: "true"
}
const _hoisted_8 = {
  key: 0,
  class: "amplify-alert amplify-alert--error"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_amplify_button = _resolveComponent("amplify-button")
  const _component_Icon = _resolveComponent("Icon")
  const _component_authenticator = _resolveComponent("authenticator")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_authenticator, {
      ref: "auth",
      "hide-sign-up": true,
      "login-mechanisms": ['email'],
      "form-fields": $data.formFields
    }, {
      header: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "header" }, [
          _createElementVNode("img", {
            class: "logo",
            src: "/assets/logo.svg"
          })
        ], -1 /* HOISTED */)
      ])),
      "sign-in-header": _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "sign-in-header" }, [
          _createElementVNode("div", { class: "sign-in-title amplify-heading amplify-heading--3" }, " Log into your account "),
          _createElementVNode("div", { class: "sign-in-subtitle" }, " Welcome back! Please enter your details. ")
        ], -1 /* HOISTED */)
      ])),
      "forgot-password-header": _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "reset-pass-title amplify-heading amplify-heading--3" }, " Reset Password ", -1 /* HOISTED */)
      ])),
      "sign-in-form": _withCtx(({onInput, onSignInSubmit, onForgotPasswordClicked}) => [
        _createElementVNode("form", {
          ref: "eform",
          method: "post",
          disabled: $data.auth.isPending || $data.loading,
          "data-amplify-form": "",
          onInput: onInput,
          onSubmit: _withModifiers(onSignInSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("fieldset", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                ($data.stage==='email')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        class: "amplify-label",
                        for: "username"
                      }, "Email", -1 /* HOISTED */)),
                      _createElementVNode("input", _hoisted_6, null, 512 /* NEED_PATCH */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                ($data.stage==='password')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        class: "amplify-label",
                        for: "password"
                      }, "Password", -1 /* HOISTED */)),
                      _createElementVNode("input", _hoisted_7, null, 512 /* NEED_PATCH */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              ($options.error_text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($options.error_text), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            ($data.stage==='email')
              ? (_openBlock(), _createBlock(_component_amplify_button, {
                  key: 0,
                  variation: "primary",
                  fullwidth: true,
                  onClick: _withModifiers($options.onEmailContinue, ["prevent"]),
                  onSubmit: _withModifiers(() => {}, ["prevent"])
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Continue ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]))
              : _createCommentVNode("v-if", true),
            ($data.stage==='password')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_amplify_button, {
                    variation: "primary",
                    fullwidth: true,
                    type: "submit"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Sign In ")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_amplify_button, {
                    style: _normalizeStyle({visibility: $data.stage === 'password' ? 'visible' : 'hidden'}),
                    variation: "link",
                    size: "small",
                    onClick: $event => ($options.onForgotPassword(onForgotPasswordClicked))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Forgot your password? ")
                    ])),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style", "onClick"])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($options.has_google && $data.stage === 'email')
              ? (_openBlock(), _createBlock(_component_amplify_button, {
                  key: 2,
                  class: "google-auth",
                  variation: "default",
                  fullwidth: true,
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.signInCustom('Google')), ["prevent"])),
                  onSubmit: _withModifiers(() => {}, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      width: "2rem",
                      height: "2rem",
                      icon: "social/google-logo",
                      style: {"margin-right":"1rem"}
                    }),
                    _cache[9] || (_cache[9] = _createTextVNode(" Sign In with Google "))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
      ]),
      "sign-in-footer": _withCtx(() => [
        _createCommentVNode(" There should be something to hide default 'Forgot password' "),
        _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1 /* HOISTED */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["form-fields"])
  ]))
}